<div style="margin:130px">
  <div class="container">
    <div class="row">
      <div class="col-sm">
        
        <h2><span class="spanleft"></span>Job Matching</h2>
        <img src="../../../assets/images/Job_Profile_Matching_new.jpg">
      </div>
      <div class="col-sm">
        <p>
          Machine Learning and AI enabled algorithm to match jobs</p>
      <button (click)="new_showComponent('landingjobprofile')">Open -></button>
      </div>
    </div>

    <div class="row" style="color: rgb(195, 189, 189);display: none;">
      <div class="col-sm">
        <p>
          Leveraging text data word cloud will be generated which could be used to quickly grasp the key words in the text. Options like unigram, bi gram etc will be available </p>
          <!-- <button (click)="new_showComponent('WordCloud')"  style="color:grey">Open -></button> -->
          <button (click)="new_showComponent('')"  style="color:grey">Open -></button>
      </div>
      <div class="col-sm" style="display:none;">
        

        <h2>Word Cloud<span class="spanright"></span></h2>
        <img src="../../../assets/images/Word_Cloud.jpg">
      </div>
   
      
    </div>
    <div class="row" style="color: rgb(195, 189, 189);display:none;">
      <div class="col-sm">
        
        <h2><span class="spanleft"></span>Theme Identification</h2>
        <img src="../../../assets/images/Theme_Identification.jpg">
      </div>
      <div class="col-sm" style="display:none;">
        <p>
          Machine learning will be used to generate key themes of the text data which will help in quick summarization of key hot spot areas around the subject</p>
      <button (click)="new_showComponent('')" title="Coming Soon" style="color:grey">Open -></button>
      </div>
      
    </div>
    <div class="row" style="color: rgb(195, 189, 189);display:none;" >
      <div class="col-sm">
        <p>
          Identifying sentiments hidden under long paragraphs, survey data, text data coming from various other sources. This will help in quickly understanding the key sentiment under category like positive, negative or neutral</p>
      <button (click)="new_showComponent('')" title="Coming Soon" style="color:grey">Open -></button>
      </div>
      <div class="col-sm" style="display:none;">
        

        <h2>Sentiment Analysis<span class="spanright"></span></h2>
        <img src="../../../assets/images/Sentiment_Analysis.jpg">
      </div>
   
      
    </div>

    <!-- <div class="row" style="color: rgb(195, 189, 189);">
      <div class="col-sm">
        
        <h2><span class="spanleft"></span>Name Entity Recognition</h2>
        <img src="../../../assets/images/Name_Entity_Recognition.jpg">
      </div>
      <div class="col-sm">
        <p>
          Machine learning algorithm will help in automatically identifying the key entities that resides in large data</p>
      <button (click)="new_showComponent('')" title="Coming Soon" style="color:grey">Open -></button>
      </div>
      
    </div> -->
    <div class="row" style="color: rgb(195, 189, 189);display:none;">
      <div class="col-sm">
        <p>
          Option to generate part of speech tagging that will enable user in quickly understanding the various part of speech components that exists in long data which in turn helps in quick decision making</p>
      <button (click)="new_showComponent('')" title="Coming Soon" style="color:grey">Open -></button>
      </div>
      <div class="col-sm" style="display:none;">
        

        <h2>Part of Speech<span class="spanright"></span></h2>
        <img src="../../../assets/images/Part_of_Speech_tagging.jpg">
      </div>
   
      
    </div>
    <div class="row" style="color: rgb(195, 189, 189);display:none;">
      <div class="col-sm">
        
        <h2><span class="spanleft"></span>Text Summarizer</h2>
        <img src="../../../assets/images/Text_Summarizer.jpg">
      </div>
      <div class="col-sm" style="display:none;">
        <p>
          Machine learning enabled  text summarizer which will help in summarizing large text data into few lines which help in understanding the gist quickly</p>
      <button (click)="new_showComponent('')" title="Coming Soon" style="color:grey">Open -></button>
      </div>
      
    </div>

  </div>
</div>
 
      <!-- </div>
    </div>
    <div class="menu" id="menu">
      <div ngClass="item item-{{i+1}}" *ngFor="let comp of componentList;let i=index">
        
        <div class="content-container">
          
          <h3 style="border-bottom: 2px solid #f1f1f1;" (click)="showComponent(comp)">{{comp.title}}</h3>
          
          <p>{{comp.description}}</p>
        </div>
        <a title="{{comp.title}}" (click)="showComponent(comp)"><i class="material-icons">home</i></a>
      </div>
    
    </div>
  </div>
</div>  -->





